import { render, staticRenderFns } from "./ToBrand.vue?vue&type=template&id=16edd720&"
import script from "./ToBrand.vue?vue&type=script&lang=ts&"
export * from "./ToBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports